import { Navigate } from 'react-router-dom';
import { tokenManager } from '../config/authConfig';

export const RoutesPrivate = {
    CIFRANEGRA: '/cifranegra'
}

// Rutas del panel de personal municipal (HU-003) — rama separada del mapa
// ciudadano, con su propio login.
export const RoutesPanel = {
    LOGIN: '/panel/login',
    INICIO: '/panel',
    SIN_PERMISO: '/panel/sin-permiso',
}

/**
 * Guard real de las rutas de personal (`/panel/*`). Sin JWT válido en
 * `tokenManager`, redirige a `/panel/login`. Con `rolesPermitidos` definido,
 * además exige que el rol guardado en la cookie de usuario esté en esa
 * lista — si no, redirige a "sin permiso" en vez de dejarlo pasar (ej. la
 * gestión de usuarios de la Fase 4 es exclusiva de `ADMINISTRADOR`).
 */
export const RutaProtegidaPanel = ({ children, rolesPermitidos = null }) => {
    if (!tokenManager.isAuthenticated()) {
        return <Navigate to={RoutesPanel.LOGIN} replace />;
    }

    if (rolesPermitidos) {
        const usuario = tokenManager.getUserData();
        if (!usuario || !rolesPermitidos.includes(usuario.usu_chRol)) {
            return <Navigate to={RoutesPanel.SIN_PERMISO} replace />;
        }
    }

    return children;
}